import i18n from "i18next";
import Backend from "i18next-chained-backend";
import ChainedBackend from "i18next-chained-backend";
import HttpBackend from "i18next-http-backend";
import LocalStorageBackend from "i18next-localstorage-backend"; // cache
import { initReactI18next } from "react-i18next";
import MultiLoadBackendAdapter from "i18next-multiload-backend-adapter";

// const requiredStructure = {
//   en: {
//     login: {
//       "login-title": "Login",
//       "login-title-2": "Login2",
//     },
//     "ops-manager": {
//       "ops-title": "test",
//     },
//   },
//   fr: {
//     login: {
//       "login-title": "LoginFr",
//     },
//   },
// };

// export default i18n
//   .use(ChainedBackend)
//   .use(initReactI18next)
//   .init({
//     react: {
//       useSuspense: false,
//     },
//     fallbackLng: "en",
//     lng: "en",
//     backend: {
//       backends: [LocalStorageBackend, MultiLoadBackendAdapter],
//       backendOptions: [
//         {
//           backend: LocalStorageBackend,
//           expirationTime: 30 * 60 * 1000, // 30 mins cache
//         },
//         {
//           backend: HttpBackend,
//           backendOption: {
//             loadPath: "api/localization/{{lng}}/{{ns}}", // for http
//             parse: function (data) {
//               // SHEP-129: The backend is already returning the required structure. Look at the above "requiredStructure" variable for more info on structure.
//               return JSON.parse(data);
//             },
//           },
//         },
//       ],
//     },
//     ns: ["login", "ops-manager"],
//     defaultNS: "login",
//   });

export default i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    react: {
      useSuspense: false,
    },
    fallbackLng: "en",
    lng: "en",
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    backend: {
      backends: [LocalStorageBackend, HttpBackend],
      backendOptions: [
        {
          projectId: "leapfrog-client", // For local storage
          expirationTime: 60 * 1000, // 1 minute
        },
        {
          loadPath: "api/localization/{{lng}}/{{ns}}", // for http
          parse: function (data) {
            let parsedObj = "";
            try {
              parsedObj = JSON.parse(data);
            } catch (ex) {
              console.error("Error during localization: " + ex);
              console.log(data);
            }
            return parsedObj;
          },
        },
      ],
    },
    ns: ["login", "ops-manager", "homepage"],
    defaultNS: "login",
  });
